export const siteInfo = {
  name: "直播翻车观察局",
  shortName: "翻车观察局",
  tagline: "把每一次翻车，还原成完整经过",
  description:
    "聚焦网红翻车现场，收录直播事故、翻车视频回放与关键截图。从带货失误到连线失控，名场面瞬间一网打尽，帮你快速定位吃瓜重点，看透每次翻车的真实经过。",
  email: "guangcha@fanche-observer.example",
  since: "2023 年春天",
};

export interface FailCategory {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  accent: string;
}

export const categories: FailCategory[] = [
  {
    slug: "live-accident",
    name: "直播事故",
    desc: "忘关麦、切错画面、提词器穿帮，那些镜头没来得及反应的三分钟。",
    icon: "ri-live-line",
    accent: "primary",
  },
  {
    slug: "sales-fail",
    name: "带货翻车",
    desc: "报价、库存、样品与售后的连环失误，从爆单到退款潮的完整链条。",
    icon: "ri-shopping-bag-3-line",
    accent: "accent",
  },
  {
    slug: "connection-chaos",
    name: "连线失控",
    desc: "能听到吗、你先说、当场挂断，连线类直播最高频的翻车模板。",
    icon: "ri-links-line",
    accent: "secondary",
  },
  {
    slug: "speech-fail",
    name: "言论翻车",
    desc: "一句话脱离语境之后的四十八小时，以及声明为什么总是第一条失效。",
    icon: "ri-chat-quote-line",
    accent: "primary",
  },
  {
    slug: "persona-collapse",
    name: "人设崩塌",
    desc: "镜头内外的反差被看见时，观众失去的其实不是好感，是信任。",
    icon: "ri-emotion-unhappy-line",
    accent: "accent",
  },
  {
    slug: "classic-moments",
    name: "名场面回放",
    desc: "被反复剪辑、模仿、做成语音包的经典瞬间，以及它们能火多久。",
    icon: "ri-movie-2-line",
    accent: "secondary",
  },
];

export const faqs = [
  {
    q: "「网红翻车」在这里具体指什么？",
    a: "我们把翻车定义为在公开直播或公开内容中，因口播、操作、设备或言行造成的明显失误，并引发广泛讨论的事件。它既包括带货价格、库存这类商业事故，也包括忘关麦、连线失控这类现场事故。",
  },
  {
    q: "网站里的时间线是怎么整理出来的？",
    a: "编辑会以公开回放、平台说明和当事方回应为主要依据，按时间顺序还原关键节点。对于只有单一来源的说法，我们会在正文中标明来源，不做定性判断。",
  },
  {
    q: "截图和视频回放可以直接转发吗？",
    a: "站内图片为契合内容的示意画面，不包含当事人真实影像。文字内容欢迎注明出处后引用，请勿用于对个人进行人身攻击或恶意传播。",
  },
  {
    q: "为什么有些事件只写了经过，没有写结论？",
    a: "很多事件在发酵期间信息并不完整。与其给一个不确定的结论，我们更倾向于把可验证的事实和不同声音并列呈现，让读者自己判断。",
  },
  {
    q: "发现内容有误，怎么反馈？",
    a: "可以通过联系我们页面留言，附上事件名称、时间点和依据来源。我们会核对后更新，并在页面底部记录修订时间。",
  },
  {
    q: "这里会收录所有热门翻车事件吗？",
    a: "不会。我们更关注有完整过程、能复盘出流程问题的案例。纯粹的情绪化争吵，除非涉及公共利益，一般不做单独整理。",
  },
];

export const ranking = [
  { rank: 1, title: "把原价说成骨折价：一场直播报价失误是怎么滚成热搜的", id: "live-price-meltdown", tag: "带货翻车", score: 96 },
  { rank: 2, title: "人设崩在了一通电话上：从甜妹到翻车的十二小时", id: "persona-off-script", tag: "人设崩塌", score: 94 },
  { rank: 3, title: "被反复回放的五段名场面：它们为什么能火这么久", id: "classic-scene-return", tag: "名场面", score: 91 },
  { rank: 4, title: "一句话得罪一整个行业：言论翻车后的四十八小时", id: "speech-slip-apology", tag: "言论翻车", score: 88 },
  { rank: 5, title: "两方主播连线比价：从互相捧场到当场翻脸", id: "connection-price-war", tag: "连线失控", score: 85 },
  { rank: 6, title: "样品和发货货不对板：一场拖了两个月的售后", id: "sales-sample-swap", tag: "带货翻车", score: 82 },
];

export const clips = [
  {
    id: "live-mic-off-air",
    title: "忘关麦三分钟：一段被完整记录的直播事故",
    duration: "03:12",
    label: "现场回放",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20broadcast%20studio%20with%20a%20single%20glowing%20red%20on%20air%20sign%20and%20empty%20chair%2C%20moody%20warm%20lighting%2C%20no%20people%2C%20cinematic&width=800&height=450&seq=fail-clip-01&orientation=landscape",
  },
  {
    id: "connection-chaos-link",
    title: "连线半小时听不见对方：一次连线失控全记录",
    duration: "02:40",
    label: "关键片段",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20blurred%20video%20call%20panels%20glowing%20on%20a%20dark%20screen%20with%20warm%20amber%20reflections%2C%20stylized%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=fail-clip-02&orientation=landscape",
  },
  {
    id: "classic-scene-return",
    title: "被反复回放的五段名场面：循环播放合集",
    duration: "05:08",
    label: "名场面",
    cover:
      "https://readdy.ai/api/search-image?query=wall%20of%20small%20blurred%20video%20thumbnails%20in%20a%20dark%20room%20with%20warm%20amber%20edge%20light%2C%20abstract%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=fail-clip-03&orientation=landscape",
  },
  {
    id: "live-script-leak",
    title: "提词器反射进镜头：剧本是怎么被看见的",
    duration: "01:56",
    label: "关键截图",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20glossy%20dark%20desk%20surface%20with%20faint%20warm%20screen%20reflection%2C%20minimal%20moody%20still%20life%2C%20no%20people%2C%20no%20text&width=800&height=450&seq=fail-clip-04&orientation=landscape",
  },
];

export const reviews = [
  {
    name: "编辑部小周",
    role: "内容从业者",
    text: "最有用的是时间线和流程复盘，不像别的地方一上来就带节奏，看完能明白到底是哪一个环节出的问题。",
  },
  {
    name: "阿麦不吃香菜",
    role: "常年吃瓜网友",
    text: "事件更新很快，而且每篇都不长，通勤路上十分钟能看完一条，重点也标得很清楚。",
  },
  {
    name: "老陈的选品笔记",
    role: "品牌运营",
    text: "我们是当成案例库在看的，报价、库存、售后这几类事故的处置方式，比很多付费课程讲得实在。",
  },
];

export const watchGuide = [
  {
    step: "01",
    title: "先看时间线",
    desc: "每篇详情页顶部都有按分钟梳理的时间线，三十秒就能抓住事件的起承转合。",
    icon: "ri-time-line",
  },
  {
    step: "02",
    title: "再看关键截图",
    desc: "截图区只保留能说明问题的画面，并标注它在时间线上的位置，避免被断章取义的片段带偏。",
    icon: "ri-image-2-line",
  },
  {
    step: "03",
    title: "最后看复盘",
    desc: "正文会拆解这次翻车暴露的流程漏洞，以及如果换一种处理方式，结果可能有什么不同。",
    icon: "ri-lightbulb-flash-line",
  },
];

export const stats = [
  { label: "已收录事件", value: "1,286", unit: "起" },
  { label: "名场面片段", value: "412", unit: "段" },
  { label: "关键截图", value: "5,730", unit: "张" },
  { label: "编辑复核", value: "100", unit: "%" },
];